import styled from 'styled-components'

import Card from '../../components/Card'
import ActionButton from '../../components/ActionButton'
import CAcceptTerms from '../../components/forms/DeclarationForm/AcceptTerms'

export const Background = styled.div<{ $background: string }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${(props) => props.$background});
  background-size: cover;
  background-position: center;
`

export const AcceptTerms = styled(CAcceptTerms)``

export const CardWrapper = styled(Card)``

export const Button = styled(ActionButton)``

export const InnerTitle = styled.p`
  ${({ theme }) => theme.textStyles.H5}
  margin-bottom: 3.2rem;
`
